import '.bh{position:fixed;}.ssr-plugin'
import '.bi{inset:0px;}.ssr-plugin'
import '.dv{background:rgba(0,0,0,0.66);}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.dw{z-index:99;}.ssr-plugin'
import '.dx{animation-duration:1s;}.ssr-plugin'
import '.dy{animation-effect:ease-in;}.ssr-plugin'
import '.n{position:relative;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.ba{max-width:440px;}.ssr-plugin'
import '.be{padding:32px;}.ssr-plugin'
import '.b8{gap:8px;}.ssr-plugin'
import '.dz{margin:24px;}.ssr-plugin'
import '.bj{overflow:hidden;}.ssr-plugin'
import '.b5{text-align:center;}.ssr-plugin'
import { styled } from 'inlines'
import { SpinningLoader } from './SpinningLoader'
import { useTheme } from '../providers/useTheme'
import { Text } from './Text'
import { useEffect } from 'react'
import { useTranslations } from '../hooks/useTranslations'
import { capitalize } from '../utils/capitalize'

export const StripeProcessing = ({
  isWaiting,
  isProcessing,
}: {
  isWaiting?: boolean
  isProcessing?: boolean
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  const { colors } = useTheme()
  const { data: dictionary } = useTranslations('checkout')

  return (
    <div className="bh bi dv a d c dw"
    >
      <div className="dx dy"
        style={{
          '@keyframes': {
            '0%': {
              opacity: 0,
            },
            '100%': {
              opacity: 1,
            },
          },}}
      />

      <div className="n h ba be d c b8 dz bj b5"
        style={{
          backgroundColor: colors.background,
          border: `1px solid ${colors.border}`,}}
      >
        <SpinningLoader size={64} style={{ margin: '0 auto' }} />
        <Text
          color="gradient"
          variant="title"
          isMultiline
          style={{ textAlign: 'center', marginBottom: 6, marginTop: 12 }}
        >
          {capitalize(dictionary?.processing_payment ?? '')}
        </Text>
        <Text style={{ textAlign: 'center' }}>
          {capitalize(
            isWaiting || isProcessing
              ? dictionary?.processing_payment_message
              : dictionary?.processing_payment_long_wait,
          )}
        </Text>
      </div>
    </div>
  )
}
